export default "__VITE_ASSET__8929bc41__"